/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import ErrorRoundedIcon from '@material-ui/icons/ErrorRounded';
import Button from 'components/common/Button';

const useStyles = makeStyles(theme => ({
  errorContainer: {
    width: '100%',
    minHeight: 'calc(100vh - 10.1875rem)',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    background: theme.palette.lightGray,
    paddingTop: '2.5rem',
  },
  title: {
    fontWeight: 600,
    fontSize: '1.2rem',
    color: theme.palette.secondary.contrastText,
    marginBottom: '0.5rem',
    lineHeight: '39px',
  },
  content: {
    fontWeight: 'normal',
    fontSize: '1.2rem',
    color: theme.palette.secondary.contrastText,
    marginBottom: '1.5rem',
  },
  icon: {
    fontSize: '5rem',
    color: theme.palette.failed,
    marginBottom: '1.5rem',
  },
}));

export default function EPCTErrorPage({ action }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const executeAction = () => {
    if (typeof action === 'function') {
      action();
      return;
    }

    window.location.reload();
  };

  return (
    <div className={classes.errorContainer}>
      <ErrorRoundedIcon className={classes.icon} />
      <Typography className={classes.title}>{t('epct.loading.error.title')}</Typography>

      <Typography className={classes.content} variant="body2">
        {t('epct.loading.error.content')}
      </Typography>

      <Button color="primary" id="retry" onClick={executeAction}>
        {t('actions.try.again')}
      </Button>
    </div>
  );
}
